/**
 * Created by charnjeetelectrovese@gmail.com on 5/1/2020.
 */

import {
    APP_SETTINGS_UPDATE_GEOFENCE,
    APP_SETTINGS_DONE,
    APP_SETTINGS_INIT, APP_SETTINGS_CHANGE_THEME,APP_SETTINGS_UPDATE_POLICIES,
    APP_SETTINGS_THEME_BY_DOMAIN
} from "../actions/AppSettings.action";

const initialState = {
    error: false,
    is_calling: true,
    geofence: [],
    theme: 'dark',
    TERMS: '',
    PRIVACY: '',
    ACCEPTABLE_USE: '',
    COOKIES: '',
    domainTheme: (() => {
        try {
            const currentDomain = (typeof window !== 'undefined' && window.location.hostname) ? window.location.hostname : '';
            const domainKey = currentDomain ? `client_theme_${currentDomain}` : null;
            const cached = (domainKey && localStorage.getItem(domainKey)) ||
                localStorage.getItem('domain_theme_data') ||
                localStorage.getItem('domainTheme');
            return cached ? JSON.parse(cached) : null;
        } catch (e) {
            return null;
        }
    })(),
};

export default function (state = JSON.parse(JSON.stringify(initialState)), action) {
    switch (action.type) {
        case APP_SETTINGS_INIT: {
            return {...state, is_calling: true };
        }
        case APP_SETTINGS_DONE: {
            return {
                ...state,
                ...action.payload,
                is_calling: false
            }
        }
        case APP_SETTINGS_UPDATE_GEOFENCE: {
            if (action.payload) {
                return {...state, geofence: action.payload};
            }
        }
        case APP_SETTINGS_CHANGE_THEME: {
            if (action.payload) {
                return {...state, theme: action.payload};
            }
        }
        case APP_SETTINGS_UPDATE_POLICIES: {
            if (action.payload) {

                const { name, value } = action.payload;
                const data = JSON.parse(JSON.stringify(state));
                data[name] = value;
                return {
                    ...state,
                    ...data
                };
            }
        }
        case APP_SETTINGS_THEME_BY_DOMAIN:
        case 'GET_THEME_BY_DOMAIN': {
            return {
                ...state,
                domainTheme: action.payload || null
            };
        }
        default: {
            return state;
        }
    }
    return state;
}
